





















import Vue from 'vue';
import Component from 'vue-class-component';
import Person from '@/components/Person.vue';
import {db} from '@/Firestore';
import {User} from '@/User';
import firebase from 'firebase';

@Component({
  components: {
    Person
  },
  firestore: {
    users: db.collection('/users')
  }
})
export default class Board extends Vue {
  users: User[] = [];

  token: null | string = null;
}
